export type ColorStop = {
    value: number
    color: readonly [number, number, number]
}

export const colormapAt = (value: number, stops: ReadonlyArray<ColorStop>) => {
    if (value <= stops[0].value) return stops[0].color
    if (value >= stops[stops.length - 1].value) return stops[stops.length - 1].color
    for (let i = 0; i < stops.length - 1; i++) {
        const hi = stops[i + 1]
        if (value < hi.value) {
            const lo = stops[i]
            const t = (value - lo.value) / (hi.value - lo.value)
            return [
                lo.color[0] + (hi.color[0] - lo.color[0]) * t,
                lo.color[1] + (hi.color[1] - lo.color[1]) * t,
                lo.color[2] + (hi.color[2] - lo.color[2]) * t,
            ] as const
        }
    }
    return stops[stops.length - 1].color
}

const glslColor = (c: readonly [number, number, number]): string =>
    `vec3(${c[0]}, ${c[1]}, ${c[2]})`

export const buildColormapGlsl = (
    stops: ReadonlyArray<ColorStop>,
    functionName: string
): string => {
    if (stops.length < 2) throw new Error(`${functionName}: need at least 2 stops`)

    const branches: string[] = [
        `    if (value <= ${stops[0].value.toFixed(4)}) return ${glslColor(stops[0].color)};`,
    ]
    for (let i = 0; i < stops.length - 1; i++) {
        const lo = stops[i]
        const hi = stops[i + 1]
        const range = (hi.value - lo.value).toFixed(4)
        branches.push(
            `    if (value < ${hi.value.toFixed(4)}) return mix(${glslColor(lo.color)}, ${glslColor(hi.color)}, (value - ${lo.value.toFixed(4)}) / ${range});`
        )
    }
    branches.push(`    return ${glslColor(stops[stops.length - 1].color)};`)
    return `vec3 ${functionName}(float value) {\n${branches.join("\n")}\n}`
}
